import { isLoadingReducer } from 'store/reducerUtils';
import { syncCustomField } from 'store/entities/customFields/actions';
import { combineReducers } from 'redux';

const isSyncronizing = isLoadingReducer(syncCustomField);

export const customFieldValueSyncPrism = combineReducers({
    isSyncronizing,
});
